// Import the Firebase modules that you need in your app.
import * as firebase from "firebase";
import * as messaging from "firebase/messaging";
import * as variables from "../../util/constants";

// Initalize and export Firebase.
const config = {
    apiKey: variables.FIREBASE_API_KEY,
    authDomain: variables.FIREBASE_AUTH_DOMAIN,
    databaseURL: variables.FIREBASE_DATABASE_URL,
    projectId: variables.FIREBASE_PROJECTID,
    storageBucket: variables.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: variables.FIREBASE_MESSAGING_SENDERID,
    appId: variables.FIREBASE_MESSAGING_APPID,
};

export default firebase.initializeApp(config);